import * as actions from '../../actions/actionTypes';

const initialState = false;

export default function sliderResultFetching(state = initialState, action) {
  switch (action.type) {
    case actions.SET_SLIDER_RESULT_FETCHING:
      return true;
    case actions.SET_SLIDER_RESULT:
      return false;
    default:
      return state;
  }
}
